module.exports = __webpack_public_path__ + "static/media/aeronave.b2f7729a.png";